const filterFields = {
    "Inventory Levels for Fulfillment": [
        { name: "sellerId", placeholder: "Seller ID", type: "text" },
        { name: "productSKU", placeholder: "Product SKU", type: "text" },
        { name: "productName", placeholder: "Product Name", type: "text" },
        // { name: "productCategory", placeholder: "Select Category", type: "dropdown", options: ["Electronics", "Clothing", "Home Appliances"] }, // Sample Dropdown Structure
        // { name: "addedDate", placeholder: "Select Date", type: "date" }, // Sample Date Structure
    ],
    "Shipping Carrier Performance": [
        { name: "sellerId", placeholder: "Seller ID", type: "text" },
        { name: "productSKU", placeholder: "Product SKU", type: "text" },
        { name: "productName", placeholder: "Product Name", type: "text" },
    ],
    "Return Tracking": [
        { name: "sellerId", placeholder: "Seller ID", type: "text" },
        { name: "productSKU", placeholder: "Product SKU", type: "text" },
        { name: "productName", placeholder: "Product Name", type: "text" },
    ],
    "Refund Tracking": [
        { name: "sellerId", placeholder: "Seller ID", type: "text" },
        { name: "productSKU", placeholder: "Product SKU", type: "text" },
        { name: "productName", placeholder: "Product Name", type: "text" },
    ],
    "Maelano Campaigns": [
        { name: "stockLevel", placeholder: "Stock Level", type: "text" },
        { name: "seller", placeholder: "Seller", type: "text" },
        { name: "category", placeholder: "Category", type: "text" },
    ],
    "Invitation Lists": [
        { name: "campaignId", placeholder: "Campaign ID", type: "text" },
        { name: "title", placeholder: "Title", type: "text" },
        { name: "position", placeholder: "Position", type: "text" },
        { name: "startDate", placeholder: "Start Date", type: "date" },
        { name: "endDate", placeholder: "End Date", type: "date" },
    ],
    "In-Store Campaigns": [
        { name: "campaignId", placeholder: "Campaign ID", type: "text" },
        { name: "title", placeholder: "Title", type: "text" },
        { name: "position", placeholder: "Position", type: "text" },
        { name: "startDate", placeholder: "Start Date", type: "date" },
        { name: "endDate", placeholder: "End Date", type: "date" },
    ],
    "Platform-Generated Coupons": [
        { name: "couponId", placeholder: "Coupon ID/Code", type: "text" },
        { name: "discountType", placeholder: "Discount Type", type: "text" },
        { name: "discountValue", placeholder: "Discount Value", type: "text" },
        { name: "status", placeholder: "Status", type: "text" },
        { name: "period", placeholder: "Period", type: "text" },
    ],
    "Seller-Generated Coupons": [
        { name: "status", placeholder: "Status", type: "text" },
        { name: "sellerId", placeholder: "Seller ID", type: "text" },
        { name: "startDate", placeholder: "Start Date", type: "date" },
        { name: "endDate", placeholder: "End Date", type: "date" },
    ],
    "Platform-Generated Vouchers": [
        { name: "status", placeholder: "Status", type: "text" },
        { name: "sellerId", placeholder: "Seller ID", type: "text" },
        { name: "startDate", placeholder: "Start Date", type: "date" },
        { name: "endDate", placeholder: "End Date", type: "date" },
    ],
    "Seller-Generated Vouchers": [
        { name: "status", placeholder: "Status", type: "text" },
        { name: "sellerId", placeholder: "Seller ID", type: "text" },
        { name: "startDate", placeholder: "Start Date", type: "date" },
        { name: "endDate", placeholder: "End Date", type: "date" },
    ],
    "Platform-provided Free Delivery": [
        { name: "offerId", placeholder: "Offer ID", type: "text" },
        { name: "sellerId", placeholder: "Seller ID", type: "text" },
        { name: "promotionPeriod", placeholder: "Promotion Period", type: "text" },
        { name: "deliveryZone", placeholder: "Delivery Zone", type: "text" },
        { name: "status", placeholder: "Status", type: "text" },
    ],
    "Seller-provided Free Delivery": [
        { name: "offerId", placeholder: "Offer ID", type: "text" },
        { name: "sellerId", placeholder: "Seller ID", type: "text" },
        { name: "promotionPeriod", placeholder: "Promotion Period", type: "text" },
        { name: "deliveryZone", placeholder: "Delivery Zone", type: "text" },
        { name: "status", placeholder: "Status", type: "text" },
    ],
    "Push Notifications": [
        { name: "status", placeholder: "Status", type: "text" },
        { name: "sellerId", placeholder: "Seller ID", type: "text" },
        { name: "startDate", placeholder: "Start Date", type: "date" },
        { name: "endDate", placeholder: "End Date", type: "date" },
    ],
    "Notification Performance Tracking": [
        { name: "status", placeholder: "Status", type: "text" },
        { name: "sellerId", placeholder: "Seller ID", type: "text" },
        { name: "startDate", placeholder: "Start Date", type: "date" },
        { name: "endDate", placeholder: "End Date", type: "date" },
    ],
    "Seller Picks Management": [
        { name: "pickId", placeholder: "Pick ID", type: "text" },
        { name: "productName", placeholder: "Product Name", type: "text" },
        { name: "sellerId", placeholder: "Seller ID", type: "text" },
        { name: "category", placeholder: "Category", type: "text" },
        { name: "period", placeholder: "Period", type: "text" },
        { name: "status", placeholder: "Status", type: "text" },
    ],
    "Picks Performance Metrics": [
        { name: "pickId", placeholder: "Pick ID", type: "text" },
        { name: "productName", placeholder: "Product Name", type: "text" },
    ],
    "Engagement Metrics by Post": [
        { name: "status", placeholder: "Status", type: "text" },
        { name: "sellerId", placeholder: "Seller ID", type: "text" },
        { name: "startDate", placeholder: "Start Date", type: "date" },
        { name: "endDate", placeholder: "End Date", type: "date" },
    ],
    "Attributes Management Overview": [
        { name: "orderId", placeholder: "Order ID", type: "text" },
        { name: "sellerName", placeholder: "Seller Name", type: "text" },
        { name: "orderDate", placeholder: "Order Date", type: "date" },
    ],
    "Inventory Management": [
        { name: "stockLevel", placeholder: "Stock Level", type: "text" },
        { name: "seller", placeholder: "Seller", type: "text" },
        { name: "category", placeholder: "Category", type: "text" },
    ],
    "Product Approval Queue": [
        { name: "stockLevel", placeholder: "Stock Level", type: "text" },
        { name: "seller", placeholder: "Seller", type: "text" },
        { name: "category", placeholder: "Category", type: "text" },
    ],
    "Stock Monitoring": [
        { name: "stockStatus", placeholder: "Stock Status", type: "text" },
        { name: "category", placeholder: "Category", type: "text" },
        { name: "seller", placeholder: "Seller", type: "text" },
        { name: "productName", placeholder: "ProductName", type: "text" },
    ],
    "Order Transactions": [
        { name: "status", placeholder: "Status", type: "text" },
        { name: "transType", placeholder: "Transaction Type", type: "text" },
        { name: "paymentMethod", placeholder: "Payment Method", type: "text" },
        { name: "date", placeholder: "Date", type: "text" },
        { name: "orderId", placeholder: "Order ID", type: "text" },
    ],
    "Purchase History": [
        { name: "orderId", placeholder: "Order ID", type: "text" },
        { name: "prodName", placeholder: "Product Name", type: "text" },
        { name: "keyword", placeholder: "Keyword", type: "text" },
        { name: "startDate", placeholder: "Start Date", type: "text" },
        { name: "endDate", placeholder: "End Date", type: "text" },
    ],
    "Refund Transactions": [
        { name: "status", placeholder: "Status", type: "text" },
        { name: "startDate", placeholder: "Start Date", type: "text" },
        { name: "endDate", placeholder: "End Date", type: "text" },
        { name: "name", placeholder: "Name", type: "text" },
        { name: "orderId", placeholder: "Order ID", type: "text" },
    ],
    'Transactions': [
        { name: 'transactionType', placeholder: 'Transaction Type', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
        { name: 'amount', placeholder: 'Amount', type: 'number' },
        { name: 'paymentMethod', placeholder: 'Payment Method', type: 'text' },
        { name: 'startDate', placeholder: 'Start Date', type: 'date' },
        { name: 'endDate', placeholder: 'End Date', type: 'date' },
    ],
    "Pricing Finance & Payment Payouts": [
        { name: 'recipientType', placeholder: 'Recipient Type', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
        { name: 'amount', placeholder: 'Amount', type: 'number' },
        { name: 'payMethod', placeholder: 'Pay Method', type: 'text' },
        { name: 'startDate', placeholder: 'Start Date', type: 'date' },
        { name: 'endDate', placeholder: 'End Date', type: 'date' },
    ],
    "Pricing Finance & Payment Payment Methods": [
        { name: 'CustomerID/name', placeholder: 'Customer ID/name', type: 'text' },
        { name: 'paymentMethod', placeholder: 'Payment method', type: 'text' },
        { name: 'type', placeholder: 'Type', type: 'text' },
        { name: 'payMethod', placeholder: 'Pay Method', type: 'text' },
        { name: 'startDate', placeholder: 'Start Date', type: 'date' },
        { name: 'endDate', placeholder: 'End Date', type: 'date' },
    ],
    "Pricing Finance & Payment Loan Applications": [
        { name: 'applicationID', placeholder: 'Application ID', type: 'text' },
        { name: 'sellerName', placeholder: 'Seller Name', type: 'text' },
        { name: 'loanType', placeholder: 'Loan Type', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
    ],
    "Pricing Finance & Payment Loan Management": [
        { name: 'applicationID', placeholder: 'Application ID', type: 'text' },
        { name: 'sellerName', placeholder: 'Seller Name', type: 'text' },
        { name: 'loanType', placeholder: 'Loan Type', type: 'text' },
        { name: 'status', placeholder: 'Status', type: 'text' },
    ],
    "Support Tickets": [
        { name: "userType", placeholder: "User Type", type: "text" },
        { name: "status", placeholder: "Status", type: "text" },
        { name: "priority", placeholder: "Priority", type: "text" },
        { name: "assignDate", placeholder: "Assigned Date", type: "text" },
        { name: "startDate", placeholder: "Start Date", type: "text" },
        { name: "endDate", placeholder: "End Date", type: "text" },
    ],
    "Content Management Training And Resources": [
        { name: 'moduleID', placeholder: 'Module ID', type: 'text' },
        { name: 'title', placeholder: 'Title', type: 'text' },
        { name: 'position', placeholder: 'Position', type: 'text' },
        { name: 'startDate', placeholder: 'Start Date', type: 'date' },
        { name: 'endDate', placeholder: 'End Date', type: 'date' },
    ],
};

export default filterFields;